/* @ngInject */
function archiveCollectionsAndTemplatesDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/archive-collections-and-templates/archive-collections-and-templates-dialog.html?$$REVISIONS$$'
  }
}

export { archiveCollectionsAndTemplatesDialogDirective }
